const Getters = {
  // 通貨
  getCurrencyListFromState: (state) => {
    return state.currencyList
  },
  // 通貨 日本円
  getCurrencyJpFromState: (state) => {
    return state.currencyJp
  },
  // 消費税率
  getTaxRateListFromState: (state) => {
    return state.taxRateList
  },
  // 国マスタ
  getCountryListFromState: (state) => {
    return state.countryList
  },
  // 国マスタ 日本
  getCountryJpFromState: (state) => {
    return state.countryJp
  },
  // 国電話番号マスタ
  getCountryCallingCodeListFromState: (state) => {
    return state.countryCallingCodeList
  },
  // 国電話番号マスタ 日本
  getCountryCallingCodeJpFromState: (state) => {
    return state.countryCallingCodeJp
  },
  // 希望入庫場所
  getReferredStorageLocationListFromState: (state) => {
    return state.preferredStorageLocationList
  },
  // 顧客カテゴリ
  getCustomerCategoryFromState: (state) => {
    return state.customerCategoryList
  },
  getCustomerCategoryMaxSortNumber: (state) => {
    return state.customerCategoryMaxSortNumber
  },
  // 商品カテゴリ
  getProductCategoryFromState: (state) => {
    return state.productCategoryList
  },
  // ブランド
  getBrandListFromState: (state) => {
    return state.brandList
  },
  getStockAdjustReasonListFromState: (state) => {
    return state.stockAdjustReasonList
  },
  // よく使う画面設定
  getOftenUseScreenListFromState: (state) => {
    return state.oftenUseScreenList
  },
  // APIアラート表示したかフラグ
  getHasDisplayedAlertFlg: (state) => {
    return state.hasDisplayedApiAlert
  },
  // FXレート
  getFxRateListFromState: (state) => {
    return state.fxRateList
  },
  // 言語設定
  getLangFromState: (state) => {
    return state.lang
  },
  // 帳票出力
  getLedgerSheetFromState: (state) => {
    return {
      header: state.ledgerSheetHeader,
      data: state.ledgerSheetData
    }
  }
}

export default Getters
